/* eslint-disable no-undef */

export const useGoogleMaps = () => {
  const getPlacePredictions = options => {
    const geocoderOK = google.maps.GeocoderStatus.OK
    return new Promise(resolve => {
      new google.maps.places.AutocompleteService().getPlacePredictions(
        options,
        (suggestions, status) => {
          resolve(status.toString() !== geocoderOK.toString() ? [] : suggestions)
        },
      )
    })
  }

  const geocode = (request: google.maps.GeocoderRequest): Promise<google.maps.GeocoderResult[]> => {
    const geocoderOK = google.maps.GeocoderStatus.OK
    return new Promise((resolve, reject) => {
      new google.maps.Geocoder().geocode(request, (results, status) => {
        if (status !== geocoderOK.toString()) {
          reject(status)
        }
        resolve(results)
      })
    })
  }

  const getAddressComponentByType = (address_components, type) => {
    return address_components.find(comp => comp.types.includes(type))
  }

  const computeRadius = bounds => {
    if (!bounds) return NaN
    const deadArea = 0.01
    const center = bounds.getCenter()
    const northEast = bounds.getNorthEast()
    return Math.abs(center.lat() - northEast.lat()) + deadArea
  }

  const getBoundingBox = (map): string | undefined => {
    return map?.getBounds()?.toUrlValue()
  }

  return {
    getPlacePredictions,
    geocode,
    getAddressComponentByType,
    computeRadius,
    getBoundingBox,
  }
}
